import { render, staticRenderFns } from "./InvoiceTemplate.vue?vue&type=template&id=4e41766b&scoped=true&"
import script from "./InvoiceTemplate.vue?vue&type=script&lang=js&"
export * from "./InvoiceTemplate.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTemplate.vue?vue&type=style&index=0&id=4e41766b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e41766b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e41766b')) {
      api.createRecord('4e41766b', component.options)
    } else {
      api.reload('4e41766b', component.options)
    }
    module.hot.accept("./InvoiceTemplate.vue?vue&type=template&id=4e41766b&scoped=true&", function () {
      api.rerender('4e41766b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/InvoiceTemplate.vue"
export default component.exports